import styled from 'styled-components';

export const WheelBox = styled.div`
  margin-top: 15%;
  display: flex;
  justify-content: center;
`;
